// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.statusLable_contained_error__xwvo7 {
  height: 24px;
  padding: 0 10px;
  border-radius: 20px;
  -webkit-user-select: none;
          user-select: none;
  display: flex;
  align-items: center;
  background-color: var(--Orange);
  color: var(--White); }
  .statusLable_contained_error__xwvo7 .statusLable_type__gf5GJ {
    font-weight: 400;
    font-size: 12px;
    line-height: 24px; }

.statusLable_contained_completed__p45-F {
  height: 24px;
  padding: 0 10px;
  border-radius: 20px;
  -webkit-user-select: none;
          user-select: none;
  display: flex;
  align-items: center;
  background-color: var(--Green);
  color: var(--White); }
  .statusLable_contained_completed__p45-F .statusLable_type__gf5GJ {
    font-weight: 400;
    font-size: 12px;
    line-height: 24px; }

.statusLable_contained_undefined__eoVVg {
  height: 24px;
  padding: 0 10px;
  border-radius: 20px;
  -webkit-user-select: none;
          user-select: none;
  display: flex;
  align-items: center;
  background-color: var(--LowEmphasis);
  color: var(--White); }
  .statusLable_contained_undefined__eoVVg .statusLable_type__gf5GJ {
    font-weight: 400;
    font-size: 12px;
    line-height: 24px; }

.statusLable_text_error__LG2q- {
  display: flex;
  align-items: center;
  color: var(--Orange); }
  .statusLable_text_error__LG2q- .statusLable_type__gf5GJ {
    font-weight: 600;
    font-size: 12px;
    line-height: 150%; }

.statusLable_text_completed__xm2nr {
  display: flex;
  align-items: center;
  color: var(--Green); }
  .statusLable_text_completed__xm2nr .statusLable_type__gf5GJ {
    font-weight: 600;
    font-size: 12px;
    line-height: 150%; }

.statusLable_text_undefined__rigH\\+ {
  display: flex;
  align-items: center;
  color: var(--LowEmphasis); }
  .statusLable_text_undefined__rigH\\+ .statusLable_type__gf5GJ {
    font-weight: 600;
    font-size: 12px;
    line-height: 150%; }

.statusLable_icon__xZni- {
  margin-right: 6px; }
`, "",{"version":3,"sources":["webpack://./src/pages/previewOrders/components/StatusLable/statusLable.module.scss","webpack://./src/styles/fonts.scss"],"names":[],"mappings":"AAeE;EAPA,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,yBAAiB;UAAjB,iBAAiB;EARjB,aAAa;EACb,mBAAmB;EAcjB,+BAA+B;EAC/B,mBAAmB,EAAA;EAJpB;ICoDD,gBAAgB;IAChB,eAAe;IACf,iBAAiB,EAAA;;AD7CjB;EAhBA,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,yBAAiB;UAAjB,iBAAiB;EARjB,aAAa;EACb,mBAAmB;EAuBjB,8BAA8B;EAC9B,mBAAmB,EAAA;EAJpB;IC2CD,gBAAgB;IAChB,eAAe;IACf,iBAAiB,EAAA;;ADpCjB;EAzBA,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,yBAAiB;UAAjB,iBAAiB;EARjB,aAAa;EACb,mBAAmB;EAgCjB,oCAAoC;EACpC,mBAAmB,EAAA;EAJpB;ICkCD,gBAAgB;IAChB,eAAe;IACf,iBAAiB,EAAA;;ADxBjB;EA1CA,aAAa;EACb,mBAAmB;EA2CjB,oBAAoB,EAAA;EAFrB;IC4BD,gBAAgB;IAChB,eAAe;IACf,iBAAiB,EAAA;;ADvBjB;EAjDA,aAAa;EACb,mBAAmB;EAkDjB,mBAAmB,EAAA;EAFpB;ICqBD,gBAAgB;IAChB,eAAe;IACf,iBAAiB,EAAA;;ADhBjB;EAxDA,aAAa;EACb,mBAAmB;EAyDjB,yBAAyB,EAAA;EAF1B;ICcD,gBAAgB;IAChB,eAAe;IACf,iBAAiB,EAAA;;ADPnB;EACE,iBAAiB,EAAA","sourcesContent":["@import 'src/styles/fonts';\n\n@mixin label {\n  display: flex;\n  align-items: center;\n}\n\n@mixin contained {\n  height: 24px;\n  padding: 0 10px;\n  border-radius: 20px;\n  user-select: none;\n}\n\n.contained {\n  &_error {\n    @include contained;\n    @include label;\n    background-color: var(--Orange);\n    color: var(--White);\n    .type {\n      @include caption;\n    }\n  }\n  &_completed {\n    @include contained;\n    @include label;\n    background-color: var(--Green);\n    color: var(--White);\n    .type {\n      @include caption;\n    }\n  }\n  &_undefined {\n    @include contained;\n    @include label;\n    background-color: var(--LowEmphasis);\n    color: var(--White);\n    .type {\n      @include caption;\n    }\n  }\n}\n\n.text {\n  &_error {\n    @include label;\n    color: var(--Orange);\n    .type {\n      @include title;\n    }\n  }\n  &_completed {\n    @include label;\n    color: var(--Green);\n    .type {\n      @include title;\n    }\n  }\n  &_undefined {\n    @include label;\n    color: var(--LowEmphasis);\n    .type {\n      @include title;\n    }\n  }\n}\n\n.icon {\n  margin-right: 6px;\n}\n","@mixin h1 {\n  font-weight: 600;\n  font-size: 32px;\n  line-height: 150%;\n}\n\n@mixin h2 {\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 150%;\n}\n\n@mixin h3 {\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n}\n\n@mixin h4 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin h5 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin h6 {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin body1 {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin body2 {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 24px;\n}\n\n@mixin body3 {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n}\n\n@mixin link1 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin link2 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin caption {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 24px;\n}\n\n@mixin title {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin button {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contained_error": `statusLable_contained_error__xwvo7`,
	"type": `statusLable_type__gf5GJ`,
	"contained_completed": `statusLable_contained_completed__p45-F`,
	"contained_undefined": `statusLable_contained_undefined__eoVVg`,
	"text_error": `statusLable_text_error__LG2q-`,
	"text_completed": `statusLable_text_completed__xm2nr`,
	"text_undefined": `statusLable_text_undefined__rigH+`,
	"icon": `statusLable_icon__xZni-`
};
export default ___CSS_LOADER_EXPORT___;
